<template>
  <div id="webViewPop" class="popWrap nowOpen">
    <span class="blind focusSet first" tabindex="0"></span>
    <div class="popup">
      <div class="popContain">
        <div class="popCont full hasBtn" tabindex="-1" role="dialog" style="overflow:auto;">
          <div class="popHead">
            <h1 class="titH1">
              {{ title }}
            </h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <section class="termsDetail">
                <!-- 본문 (s) -->
                <p v-for="(webView, webViewIndex) in list" :key="webViewIndex">
                  <span v-html="webView.webViewTitle" style="font-size: 20px; font-weight: bold;"></span>
                  <span v-html="webView.webView"></span>
                </p>
                <!-- 본문 (e) -->
              </section>
            </div>
          </div>

          <div class="btnArea sticky">
            <slot name="bottomButton">
              <button type="button" class="btn_p" @click="$emit('close')">
                닫기
              </button>
            </slot>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')">
            <span>팝업 닫기</span>
          </button>
        </div>
      </div>
    </div>
    <span class="blind focusSet last" tabindex="0"></span>
  </div>
</template>
<script>
import ApiService from '@/common/api.service';

export default {
  name: 'WebViewPop',
  props: ['webViewList'],
  mounted() {
    for (let webView of this.webViewList) {
      ApiService.get(webView.filePath)
        .then(({ data }) => {
          let obj = new Object();
          obj.webView = data;
          obj.webViewTitle = webView.webviewName;
          this.list.push(obj);
          console.log('test ":: ' + JSON.stringify(this.list));
        })
        .catch(({ response }) => {
          console.log(response);
        });
    }
  },
  data: function() {
    return {
      list: [],
      title: this.webViewList[0].webviewName,
    };
  },
};
</script>
